import { Robot, ArrowsLeftRight, Eye } from "@phosphor-icons/react";

const MODES = [
  { id: "annotated", label: "AI Annotated", icon: Robot },
  { id: "side-by-side", label: "Side by Side", icon: ArrowsLeftRight },
  { id: "overlay", label: "Red/Blue Overlay", icon: Eye },
];

/**
 * Tab/pill switcher for comparison view modes.
 */
export default function ComparisonViewModes({ activeMode, onModeChange }) {
  return (
    <div className="flex items-center gap-1 px-3 py-2 bg-slate-50 border-b border-slate-200">
      <span className="text-xs font-medium text-slate-500 mr-2">View:</span>
      <div className="flex items-center bg-slate-200/60 rounded-md p-0.5">
        {MODES.map(({ id, label, icon: Icon }) => {
          const isActive = activeMode === id;
          return (
            <button
              key={id}
              onClick={() => onModeChange(id)}
              className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-all ${
                isActive
                  ? "bg-white text-primary shadow-sm"
                  : "text-slate-500 hover:text-slate-700"
              }`}
              data-testid={`view-mode-${id}`}
            >
              <Icon size={14} weight={isActive ? "fill" : "regular"} />
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
